









































































import {
  ComputationBinaryOperators,
  ComputationNodeSubtype,
  IQuoteServiceVariable,
  IServiceComputationNode,
  ServiceComputationFieldError,
  ServicePriceComputation
} from '@/models';
import Vue, { PropType } from 'vue';
import { get } from 'vuex-pathify';
import ComputationView from '@/components/computation/ComputationView.vue';

export default Vue.extend({
  components: {
    ComputationView
  },
  name: 'ComputationDetail',

  props: {
    value: {
      required: false,
      type: Object as PropType<ServicePriceComputation>,
      default: () => new ServicePriceComputation()
    },

    fieldError: {
      required: false,
      type: Object as PropType<ServiceComputationFieldError>,
      default: () => new ServiceComputationFieldError()
    },

    disabled: {
      type: Boolean,
      default: false
    },

    multiple: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      internalLazyValue: this.value,
      showComputation: false,
      canHideComputation: false
    };
  },

  computed: {
    descriptionRules() {
      if (!this.multiple) {
        return [(v?: string) => true];
      }
      return [(v: string) => !!v || 'Description is required'];
    },

    getQuoteServiceVariableById: get<
      (id: number) => IQuoteServiceVariable | undefined
    >('quoteServiceVariable/getQuoteServiceVariableById'),

    internalValue: {
      get(): unknown {
        return this.internalLazyValue;
      },
      set(val: any) {
        if (val === this.internalLazyValue) return;

        this.internalLazyValue = val;

        // hack for passing multiple function on the emit values
        this.$emit('input', val);
      }
    },

    computeStringExpressionFromNodes(): string {
      let stringExpression = '';

      (this.internalValue.nodes as IServiceComputationNode[]).map(node => {
        if (node.isOperand()) {
          switch (node.subtype) {
            case ComputationNodeSubtype.constant:
              stringExpression = stringExpression?.concat(
                String(node.constant)
              );
              break;
            case ComputationNodeSubtype.variable:
              stringExpression = stringExpression?.concat(
                String(
                  `${this.getQuoteServiceVariableById(node.variable!)?.value ??
                    null}`
                )
              );
              break;
            case ComputationNodeSubtype.item_exists:
            case ComputationNodeSubtype.item_quantity:
              if (node.items) {
                if (node.items?.length > 2) {
                  stringExpression = stringExpression?.concat(
                    `(${node.items?.length} items)`
                  );
                } else {
                  stringExpression = stringExpression?.concat(
                    `(${String(node.items)})`
                  );
                }
              }
              break;
            case ComputationNodeSubtype.days_computation:
              stringExpression = stringExpression?.concat(
                `# of days for service`
              );
              break;
            case ComputationNodeSubtype.item_tag_quantity:
            case ComputationNodeSubtype.item_tag_exists:
              if (node.item_tags) {
                if (node.item_tags?.length > 2) {
                  stringExpression = stringExpression?.concat(
                    `(${node.item_tags?.length} tags)`
                  );
                } else {
                  stringExpression = stringExpression?.concat(
                    `(${String(node.item_tags)} tag)`
                  );
                }
              }
              break;
          }
        } else {
          switch (node.subtype) {
            case ComputationBinaryOperators.add:
              stringExpression = stringExpression?.concat(' + ');
              break;
            case ComputationBinaryOperators.subtract:
              stringExpression = stringExpression?.concat(' - ');
              break;
            case ComputationBinaryOperators.multiply:
              stringExpression = stringExpression?.concat(' * ');
              break;
            case ComputationBinaryOperators.divide:
              stringExpression = stringExpression?.concat(' / ');
              break;
            case ComputationBinaryOperators.exponent:
              stringExpression = stringExpression?.concat(' ^ ');
              break;
            case ComputationBinaryOperators.start_bracket:
              stringExpression = stringExpression?.concat(' ( ');
              break;
            case ComputationBinaryOperators.close_bracket:
              stringExpression = stringExpression?.concat(' ) ');
              break;
            case ComputationBinaryOperators.ceil:
              stringExpression = stringExpression?.concat(' Ceil');
              break;
            case ComputationBinaryOperators.floor:
              stringExpression = stringExpression?.concat(' Floor');
              break;
            case ComputationBinaryOperators.abs:
              stringExpression = stringExpression?.concat(' Abs');
              break;
          }
        }
      });
      return stringExpression;
    }
  },

  watch: {
    value(val) {
      this.internalLazyValue = val;
    }
  },

  methods: {
    addComputationNodeGroup() {
      this.$emit('add:node-group');
    },

    removeComputation() {
      this.$emit('remove:computation');
    },

    toggleShowComputation() {
      this.showComputation = !this.showComputation;
    },

    updateCanHideComputation(value: boolean) {
      this.canHideComputation = value;
      if (value && !this.showComputation) {
        this.showComputation = true;
      }
    }
  }
});
